export const TOKEN_TYPE = 'tokenType'
export const TOKEN_VALUE = "auth_token"
export const USER_DATA = 'userData'
export const STORE_DATA = 'storeItem'